import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import { useTheme } from "@mui/material/styles";
import { Controller, useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import Ternary from "src/components/ternary";
import Translate from "src/components/translate";
import axiosInstance from "src/utils/axios";
import fetchUser from "src/utils/fetchUser";
import * as Yup from "yup";
import { PATH_DASHBOARD } from "src/routes/paths";
import { useNavigate } from "react-router";

const RootStyle = styled("div")(({ theme }) => ({
  margin: theme.spacing(3),
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));

const ReasonForm = ({ title, open, selectedId, onClose, fetchData }) => {
  const { enqueueSnackbar } = useSnackbar();
  const ReviewSchema = Yup.object().shape({
    reason: Yup.string().required("Remarks is required"),
  });

  const defaultValues = {
    reason: "",
  };

  const methods = useForm({
    resolver: yupResolver(ReviewSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;
  const navigate = useNavigate();

  const onSubmit = async (inputData) => {
    const reqData = new FormData();
    reqData.append("status", "rejected");
    reqData.append("remarks", inputData.reason);

    try {
      const { status, data: responseData } = await axiosInstance.post(
        `/api/admin/approve-partner-request/${selectedId}`,
        reqData
      );
      if (status === 200) {
        enqueueSnackbar(responseData.message);
        onClose();
        fetchData();
        methods.reset();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const { palette } = useTheme();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      aria-labelledby="delete-blog"
    >
      <DialogTitle id="delete-blog">{title} Retail Partner Request</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box
            sx={{
              display: "grid",
              rowGap: 3,
              columnGap: 2,
              marginTop: 3,
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(1, 1fr)",
              },
            }}
          >
            <Typography>
              <Translate>tools.videos.areYouSure</Translate>
            </Typography>
          </Box>
        </DialogContentText>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3} marginTop={3}>
            <RHFTextField
              name="reason"
              label={"Remarks *"}
              multiline
              fullWidth
              rows={3}
            />
          </Stack>

          <DialogActions>
            <Button
              onClick={() => {
                onClose();
                methods.reset();
              }}
              autoFocus
              sx={{ color: palette.error.main }}
              name="close"
            >
              <Translate>tools.videos.close</Translate>
            </Button>
            <LoadingButton
              loading={isSubmitting}
              type="submit"
              variant="contained"
              name="delete"
            >
              {title}
            </LoadingButton>
          </DialogActions>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

export default ReasonForm;
